import { axiosInstance } from "./globals";
import * as userService from "./userService";
import {CustomerMeetingsCountRequest} from "@/model/filters";
import {DataSourceRequest} from "@/model/DataSourceRequest";
import * as util from "@/service/util";

export async function getDashboardOverview() {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get("/Reports/DashboardOverview", { headers })).data;
}

export async function getMeetingListToday() {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get("/Reports/GetMeetingListToday", { headers })).data;
}

export async function getMeetingParticipants(fromDate: string, toDate: string) {
  const headers = userService.getAuthHeaders();
  const params = { fromDate, toDate };
  return (await axiosInstance.get("/Reports/GetMeetingParticipants", { headers, params })).data;
}

export async function getCustomerMeetingsCount(filter: CustomerMeetingsCountRequest) {
  const headers = userService.getAuthHeaders();

  const params = {
    fromDate: filter.fromDate,
    toDate: filter.toDate
  };
  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: filter.sorts
  };

  const filterCount = util.countPredicate([
    filter.q, filter.areaId
  ]);

  if (filter.q && filterCount === 1) {
    body.filters = [
      { field: "customerCode", operator: "contains", value: filter.q, logic: "or" },
      { field: "name", operator: "contains", value: filter.q, logic: "or" },
    ];

  } else {
    if (filter.areaId) {
      body.filters.push(
        { field: "areaId", operator: "eq", value: filter.areaId, logic: "and" }
      );
    }

    if (filter.q) {
      body.filters[0].filters = [
        { field: "customerCode", operator: "contains", value: filter.q, logic: "or" },
        { field: "name", operator: "contains", value: filter.q, logic: "or" },
      ];
    }
  }
  return (await axiosInstance.post("/Reports/CustomerMeetingsCount", body, { headers, params })).data;
}


export async function getCustomerMeetingsCountDetails(filter: CustomerMeetingsCountRequest) {
  const headers = userService.getAuthHeaders();

  const params = {
    fromDate: filter.fromDate,
    toDate: filter.toDate
  };
  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: filter.sorts
  };

  const filterCount = util.countPredicate([
    filter.q, filter.areaId
  ]);

  if (filter.q && filterCount === 1) {
    body.filters = [
      { field: "name", operator: "contains", value: filter.q, logic: "or" },
      { field: "customerAddress", operator: "contains", value: filter.q, logic: "or" },
    ];

  } else {
    if (filter.areaId) {
      body.filters.push(
        { field: "areaId", operator: "eq", value: filter.areaId, logic: "and" }
      );
    }

    if (filter.q) {
      body.filters[0].filters = [
        { field: "name", operator: "contains", value: filter.q, logic: "or" },
        { field: "customerAddress", operator: "contains", value: filter.q, logic: "or" },
      ];
    }
  }

  return (await axiosInstance.post("/Reports/CustomerMeetingCountDetails", body, { headers, params })).data;
}

export async function getMeetingsCountDetails(fromDate: string, toDate: string) {
  const headers = userService.getAuthHeaders();
  const params = { fromDate, toDate };

  return (await axiosInstance.get("/Reports/MeetingCountDetails", { headers, params })).data;
}

export async function getMeetingListByCustomerUser(filter: CustomerMeetingsCountRequest) {
  const headers = userService.getAuthHeaders();

  const params = {
    fromDate: filter.fromDate,
    toDate: filter.toDate
  };
  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: filter.sorts
  };

  const filterCount = util.countPredicate([
    filter.q, filter.areaId
  ]);

  if (filter.q && filterCount === 1) {
    body.filters = [
      { field: "User.Name", operator: "contains", value: filter.q, logic: "or" },
      { field: "Meeting.Name", operator: "contains", value: filter.q, logic: "or" },
    ];

  } else {
    if (filter.areaId) {
      body.filters.push(
        { field: "areaId", operator: "eq", value: filter.areaId, logic: "and" }
      );
    }

    if (filter.q) {
      body.filters[0].filters = [
        { field: "User.Name", operator: "contains", value: filter.q, logic: "or" },
      { field: "Meeting.Name", operator: "contains", value: filter.q, logic: "or" },
      ];
    }
  }
  return (await axiosInstance.post("/Meeting/GetMeetingListByCustomerUser", body, { headers, params })).data;
}